import { render, staticRenderFns } from "./ElectricityCardDetailFour.vue?vue&type=template&id=18ed44ee&scoped=true&"
import script from "./ElectricityCardDetailFour.vue?vue&type=script&lang=js&"
export * from "./ElectricityCardDetailFour.vue?vue&type=script&lang=js&"
import style0 from "./ElectricityCardDetailFour.vue?vue&type=style&index=0&id=18ed44ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ed44ee",
  null
  
)

export default component.exports